import { render, staticRenderFns } from "./isu_strategis.vue?vue&type=template&id=079302b4&"
import script from "./isu_strategis.vue?vue&type=script&lang=js&"
export * from "./isu_strategis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports